import { render, staticRenderFns } from "./UcPaymentInvoices.yaml?vue&type=template&id=3a929f47&component"
import script from "./UcPaymentInvoices.yaml?vue&type=script&lang=ts&component"
export * from "./UcPaymentInvoices.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports